module.exports = __webpack_public_path__ + "img/3-3.08dc20e8.svg";